/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Lifetimeindays2Inputs */

const en_entity_lifetimeindays2 = /** @type {(inputs: Entity_Lifetimeindays2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifetime (days)`)
};

const de_entity_lifetimeindays2 = /** @type {(inputs: Entity_Lifetimeindays2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensdauer (Tage)`)
};

/**
* | output |
* | --- |
* | "Lifetime (days)" |
*
* @param {Entity_Lifetimeindays2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_lifetimeindays2 = /** @type {((inputs?: Entity_Lifetimeindays2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Lifetimeindays2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_lifetimeindays2(inputs)
	return de_entity_lifetimeindays2(inputs)
});
export { entity_lifetimeindays2 as "entity_lifetimeInDays" }